import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";
import { ActionButton } from "../components/common/ActionButton";
import { useVirtualConversation } from "../hooks/useVirtualConversation";

export const HomePageCtaButtons = () => {
  const { startVirtualConversation } = useVirtualConversation();

  const { currentCommunitySettings, isLoading: isLoadingPunditUserContext } =
    usePunditUserContext();
  const isCopilotActionsEnabled =
    !isLoadingPunditUserContext && currentCommunitySettings?.copilot_v2_enabled;

  const onActionButtonClick = (
    type: "chat" | "feedback" | "report_bug" | "copilot_action",
  ) => {
    startVirtualConversation(type);
  };

  return (
    <div className="mt-6 flex w-full flex-col items-center gap-2">
      <div className="flex w-full justify-center gap-2">
        <ActionButton
          iconName="sw-question"
          text={t("help_widget.home_page.ask_question")}
          onClick={() => onActionButtonClick("chat")}
        />
        <ActionButton
          iconName="sw-report-bug"
          text={t("help_widget.home_page.report_bug")}
          onClick={() => onActionButtonClick("report_bug")}
        />
      </div>
      <div className="flex w-full justify-center gap-2">
        <ActionButton
          iconName="sw-feedback"
          text={t("help_widget.home_page.give_feedback")}
          onClick={() => onActionButtonClick("feedback")}
        />
        {isCopilotActionsEnabled && (
          <ActionButton
            iconName="16-stars-ai"
            text={t("help_widget.home_page.perform_an_action")}
            onClick={() => onActionButtonClick("copilot_action")}
          />
        )}
      </div>
    </div>
  );
};
